import { j as p } from "./jsx-runtime-3tyXYecC.mjs";
import * as y from "react";
import { forwardRef as lt } from "react";
import { F as dt } from "./fabric-icon-CNOLIwc_.mjs";
import { c as ct } from "./index-DkZ16bcJ.mjs";
import { l as A } from "./lodash-5ofSKtz3.mjs";
import { f as pt } from "./index-LyFokDcn.mjs";
import { I as ut } from "./icon-v2-DGtVEk7e.mjs";
import { g as vt, c as F } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { s as P, b as gt, r as xt, u as bt, c as ft } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { m as St } from "./memoTheme-BzXKG_-k.mjs";
import { c as yt } from "./createSimplePaletteValueFilter-B7--0ryQ.mjs";
import { g as wt } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { B as zt } from "./ButtonBase-BIvHZGlt.mjs";
import { c as i, b as S } from "./tss-DN0acMKN.mjs";
import { e as mt } from "./enhance-anchor-props-DgCJ7ag3.mjs";
import { w as r } from "./sizes-DktS74Qp.mjs";
function Bt(t) {
  return vt("MuiButton", t);
}
const f = wt("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), Ct = /* @__PURE__ */ y.createContext({}), It = /* @__PURE__ */ y.createContext(void 0), ht = (t) => {
  const {
    color: o,
    disableElevation: n,
    fullWidth: a,
    size: e,
    variant: l,
    classes: d
  } = t, u = {
    root: ["root", l, `${l}${i(o)}`, `size${i(e)}`, `${l}Size${i(e)}`, `color${i(o)}`, n && "disableElevation", a && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${i(e)}`],
    endIcon: ["icon", "endIcon", `iconSize${i(e)}`]
  }, s = ft(u, Bt, d);
  return {
    ...d,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...s
  };
}, Z = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], $t = P(zt, {
  shouldForwardProp: (t) => gt(t) || t === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (t, o) => {
    const {
      ownerState: n
    } = t;
    return [o.root, o[n.variant], o[`${n.variant}${i(n.color)}`], o[`size${i(n.size)}`], o[`${n.variant}Size${i(n.size)}`], n.color === "inherit" && o.colorInherit, n.disableElevation && o.disableElevation, n.fullWidth && o.fullWidth];
  }
})(St(({
  theme: t
}) => {
  const o = t.palette.mode === "light" ? t.palette.grey[300] : t.palette.grey[800], n = t.palette.mode === "light" ? t.palette.grey.A100 : t.palette.grey[700];
  return {
    ...t.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (t.vars || t).shape.borderRadius,
    transition: t.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: t.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${f.disabled}`]: {
      color: (t.vars || t).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (t.vars || t).shadows[2],
        "&:hover": {
          boxShadow: (t.vars || t).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (t.vars || t).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (t.vars || t).shadows[8]
        },
        [`&.${f.focusVisible}`]: {
          boxShadow: (t.vars || t).shadows[6]
        },
        [`&.${f.disabled}`]: {
          color: (t.vars || t).palette.action.disabled,
          boxShadow: (t.vars || t).shadows[0],
          backgroundColor: (t.vars || t).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${f.disabled}`]: {
          border: `1px solid ${(t.vars || t).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(t.palette).filter(yt()).map(([a]) => ({
      props: {
        color: a
      },
      style: {
        "--variant-textColor": (t.vars || t).palette[a].main,
        "--variant-outlinedColor": (t.vars || t).palette[a].main,
        "--variant-outlinedBorder": t.vars ? `rgba(${t.vars.palette[a].mainChannel} / 0.5)` : S(t.palette[a].main, 0.5),
        "--variant-containedColor": (t.vars || t).palette[a].contrastText,
        "--variant-containedBg": (t.vars || t).palette[a].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (t.vars || t).palette[a].dark,
            "--variant-textBg": t.vars ? `rgba(${t.vars.palette[a].mainChannel} / ${t.vars.palette.action.hoverOpacity})` : S(t.palette[a].main, t.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (t.vars || t).palette[a].main,
            "--variant-outlinedBg": t.vars ? `rgba(${t.vars.palette[a].mainChannel} / ${t.vars.palette.action.hoverOpacity})` : S(t.palette[a].main, t.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": t.vars ? t.vars.palette.Button.inheritContainedBg : o,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": t.vars ? t.vars.palette.Button.inheritContainedHoverBg : n,
            "--variant-textBg": t.vars ? `rgba(${t.vars.palette.text.primaryChannel} / ${t.vars.palette.action.hoverOpacity})` : S(t.palette.text.primary, t.palette.action.hoverOpacity),
            "--variant-outlinedBg": t.vars ? `rgba(${t.vars.palette.text.primaryChannel} / ${t.vars.palette.action.hoverOpacity})` : S(t.palette.text.primary, t.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: t.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: t.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: t.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: t.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: t.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: t.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${f.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${f.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }]
  };
})), Rt = P("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (t, o) => {
    const {
      ownerState: n
    } = t;
    return [o.startIcon, o[`iconSize${i(n.size)}`]];
  }
})({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, ...Z]
}), Et = P("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (t, o) => {
    const {
      ownerState: n
    } = t;
    return [o.endIcon, o[`iconSize${i(n.size)}`]];
  }
})({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, ...Z]
}), Pt = /* @__PURE__ */ y.forwardRef(function(o, n) {
  const a = y.useContext(Ct), e = y.useContext(It), l = xt(a, o), d = bt({
    props: l,
    name: "MuiButton"
  }), {
    children: u,
    color: s = "primary",
    component: m = "button",
    className: B,
    disabled: w = !1,
    disableElevation: T = !1,
    disableFocusRipple: c = !1,
    endIcon: v,
    focusVisibleClassName: N,
    fullWidth: C = !1,
    size: I = "medium",
    startIcon: g,
    type: z,
    variant: W = "text",
    ...h
  } = d, x = {
    ...d,
    color: s,
    component: m,
    disabled: w,
    disableElevation: T,
    disableFocusRipple: c,
    fullWidth: C,
    size: I,
    type: z,
    variant: W
  }, b = ht(x), $ = g && /* @__PURE__ */ p.jsx(Rt, {
    className: b.startIcon,
    ownerState: x,
    children: g
  }), k = v && /* @__PURE__ */ p.jsx(Et, {
    className: b.endIcon,
    ownerState: x,
    children: v
  }), R = e || "";
  return /* @__PURE__ */ p.jsxs($t, {
    ownerState: x,
    className: F(a.className, b.root, B, R),
    component: m,
    disabled: w,
    focusRipple: !c,
    focusVisibleClassName: F(b.focusVisible, N),
    ref: n,
    type: z,
    ...h,
    classes: b,
    children: [$, u, k]
  });
}), Tt = ["submit", "button", "reset"];
function Nt(t) {
  const { component: o, href: n, type: a } = t;
  return (o === "button" || !o) && (!a || !Tt.includes(a)) && !n ? "submit" : a;
}
function Wt(t, o = 0) {
  return typeof t == "string" && (t = parseInt(t)), !t || isNaN(t) ? o : t;
}
const V = {
  getAllowedButtonTypes: Nt,
  sanitizeTabIndex: Wt
}, Qt = lt(
  ({
    active: t,
    alignContent: o = "center",
    ariaLabel: n,
    "aria-label": a,
    classes: e = {},
    className: l,
    color: d = "primary",
    children: u,
    component: s = "button",
    dark: m,
    disabled: B,
    endIcon: w,
    focused: T,
    href: c,
    icon: v,
    noSpacing: N,
    processing: C,
    startIcon: I,
    size: g,
    tabindex: z,
    toggled: W,
    type: h,
    variant: x = "contained",
    width: b,
    // deprecated props below
    clickAction: $,
    isActive: k,
    isDisabled: R,
    isFocused: Lt,
    isProcessing: tt,
    iconAfter: L,
    iconBefore: O,
    outline: ot,
    secondary: at,
    text: M,
    ...nt
  }, rt) => {
    const it = I || O, j = w || L, et = ot ? "outlined" : x, st = n || a;
    return /* @__PURE__ */ p.jsx(
      Pt,
      {
        classes: e,
        className: ct(
          l,
          // avoid global anchor styles
          { "fab-LinkUnstyled": s === "a" || !!c },
          // TODO: remove once we're sure this is not needed
          { "fab2-LinkUnstyled": s === "a" || !!c }
        ),
        color: at ? "secondary" : d,
        component: s,
        disabled: B || C || R || tt,
        endIcon: E(j, g),
        onClick: $,
        ref: rt,
        startIcon: E(it, g),
        tabIndex: V.sanitizeTabIndex(z),
        type: V.getAllowedButtonTypes({
          children: u,
          component: s,
          endIcon: j,
          href: c,
          iconAfter: L,
          iconBefore: O,
          icon: v,
          text: M,
          type: h
        }),
        variant: et,
        ...mt({ ...nt, "aria-label": st, href: c }),
        children: /* @__PURE__ */ p.jsx("span", { className: e.content, children: v ? E(v, g) : u || M })
      }
    );
  }
);
function E(t, o = "medium") {
  return pt.ifFeature(
    "encore",
    A.isString(t) ? /* @__PURE__ */ p.jsx(ut, { name: t, size: kt(o) }) : t,
    A.isString(t) ? /* @__PURE__ */ p.jsx(dt, { name: t }) : t
  );
}
function kt(t) {
  switch (t) {
    case "extra-small":
    case "teenie":
      return 12;
    case "large":
    case "biggie":
    case "huge":
      return 20;
    default:
      return 16;
  }
}
const Zt = "0 1px 0 0 rgba(0, 0, 0, 0.05)", to = "0 1px 0 0 rgba(0, 0, 0, 0)";
var U, D, _, H, G, X, Y, q, J, K, Q;
const oo = {
  width1: {
    width: (U = r) == null ? void 0 : U[1]
  },
  width2: {
    width: (D = r) == null ? void 0 : D[2]
  },
  width3: {
    width: (_ = r) == null ? void 0 : _[3]
  },
  width4: {
    width: (H = r) == null ? void 0 : H[4]
  },
  width5: {
    width: (G = r) == null ? void 0 : G[5]
  },
  width6: {
    width: (X = r) == null ? void 0 : X[6]
  },
  width7: {
    width: (Y = r) == null ? void 0 : Y[7]
  },
  width8: {
    width: (q = r) == null ? void 0 : q[8]
  },
  width9: {
    width: (J = r) == null ? void 0 : J[9]
  },
  width10: {
    width: (K = r) == null ? void 0 : K[10]
  },
  width100: {
    width: (Q = r) == null ? void 0 : Q[100]
  }
};
export {
  Ct as B,
  to as T,
  It as a,
  Zt as b,
  Qt as c,
  oo as w
};
//# sourceMappingURL=widths.styles-CkAQdON2.mjs.map
